import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, FrownIcon, ClockIcon, HeartIcon } from 'lucide-react';
export function PainPoints() {
  const painPoints = [{
    icon: <XIcon className="w-6 h-6 text-[#00A86B]" data-id="element-221" />,
    title: 'Hacés keto, pero siempre terminás comiendo cualquier cosa.',
    desc: 'Empezás la semana con buenas intenciones y el miércoles ya estás pidiendo delivery porque no sabés qué cocinar y no tenés tiempo para inventar.'
  }, {
    icon: <FrownIcon className="w-6 h-6 text-[#00A86B]" data-id="element-222" />,
    title: 'Tenés el Air Fryer pero lo usás para dos o tres recetas siempre iguales.',
    desc: 'Lo compraste para comer mejor, pero sin un recetario keto concreto, siempre terminás haciendo lo mismo. Y cuando te aburrís, la dieta se hace cada vez más difícil de sostener.'
  }, {
    icon: <ClockIcon className="w-6 h-6 text-[#00A86B]" data-id="element-223" />,
    title: 'No podés pasarte media hora pensando qué cocinar cada día.',
    desc: 'Entre el trabajo, la casa y las responsabilidades, lo último que querés es ponerte a buscar recetas. Y así siempre terminás en la rotisería o el delivery gastando el doble.'
  }, {
    icon: <HeartIcon className="w-6 h-6 text-[#00A86B]" data-id="element-224" />,
    title: 'Sabés que el keto funciona, pero no estás logrando sostenerlo.',
    desc: 'No es falta de voluntad. Es que sin un plan concreto y recetas ricas y rápidas, cualquier dieta se abandona. Cuando comer sano es un sacrificio, es imposible sostenerlo.'
  }];
  return <section className="bg-white py-12 px-4 md:py-20" data-id="element-225">
      <div className="max-w-[800px] mx-auto" data-id="element-226">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-227">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-gray-900 mb-4" data-id="element-228">
            ¿Tenés Air Fryer pero seguís haciendo{' '}
            <span className="text-[#00A86B]" data-id="element-229">siempre lo mismo</span>?
          </h2>
          <p className="text-gray-500 text-base md:text-lg" data-id="element-230">
            Si llegaste hasta acá, probablemente te sentís identificada con
            alguna de estas situaciones.
          </p>
        </motion.div>
        <div className="space-y-4" data-id="element-231">
          {painPoints.map((point, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="flex flex-col sm:flex-row gap-4 p-5 rounded-2xl bg-gray-50 border border-gray-100 hover:shadow-md transition-shadow" data-id="element-232">
              <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-[#00A86B]/10 flex items-center justify-center" data-id="element-233">
                {point.icon}
              </div>
              <div data-id="element-234">
                <h3 className="font-heading font-bold text-gray-900 mb-2" data-id="element-235">
                  {point.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed" data-id="element-236">
                  {point.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}